import { FormControl, FormControlLabel, Grid, Radio, RadioGroup } from '@material-ui/core';
import { Alert, Skeleton } from '@material-ui/lab';
import React, { useMemo } from 'react';
import { ImageFallback } from 'utils';
import { v4 as uuidv4 } from 'uuid';
import styles from './styles.module.css';

const PaymentMethodItem = ({ item, isSelected, onChange, locale = 'en' }) => {
  const { code, name, subTitle, url, isDisable, svgIcons = [] } = item || {};
  const paymentMethodName = item[`name_${locale}`] || name || '';
  const paymentMethodSubTitle = item[`subTitle_${locale}`] || subTitle || '';

  return (
    <RadioGroup className={styles.fieldset} value={isSelected && code} onChange={onChange}>
      <FormControlLabel
        className={`${isSelected ? 'active_payment' : ''}`}
        value={code}
        disabled={isDisable}
        control={
          <Radio
            classes={{
              root: isSelected ? styles.checkbox_color : styles.noncheckbox_color,
            }}
            data-test="radio-checkout-payment"
            size="small"
          />
        }
        label={
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid item xs={10} container direction="column" justifyContent="center">
              <Grid item>
                <h6 className={styles.fw500}>{paymentMethodName}</h6>
              </Grid>
              {paymentMethodSubTitle?.length > 0 && (
                <Grid item>
                  <div className={styles.subTitle}>
                    {url.length > 0 ? (
                      <a href={url} target="_blank" rel="noreferrer">
                        {paymentMethodSubTitle}
                      </a>
                    ) : (
                      paymentMethodSubTitle
                    )}
                  </div>
                </Grid>
              )}
            </Grid>
            <Grid item xs={2} className={styles.textRight}>
              {svgIcons.map((svgIconURL) => (
                <ImageFallback
                  key={svgIconURL}
                  src={svgIconURL}
                  alt={paymentMethodName}
                  width="40px"
                  height="36px"
                />
              ))}
            </Grid>
          </Grid>
        }
      />
    </RadioGroup>
  );
};

const PaymentMethodWeb = ({
  handleChange,
  selectedVal = '',
  paymentMethods = [],
  errorMessage,
  description,
  locale,
  translateCheckout,
}) => {
  const checkExistDescriptionContent = useMemo(
    () => description && description.length > 0 && description !== '<p></p>\n',
    [description],
  );

  return (
    <>
      <h1 className={styles.title}>{translateCheckout('payment_method')}</h1>
      <FormControl component="fieldset">
        <div className={styles.paymentMethodsGrid}>
          {paymentMethods?.length > 0 ? (
            paymentMethods.map((item) => (
              <PaymentMethodItem
                key={item.code}
                item={item}
                isSelected={selectedVal === item.code}
                onChange={handleChange}
                locale={locale}
              />
            ))
          ) : (
            <>
              <Skeleton variant="rect" width="100%" height={70} />
              <Skeleton variant="rect" width="100%" height={70} />
              <Skeleton variant="rect" width="100%" height={70} />
              <Skeleton variant="rect" width="100%" height={70} />
              <Skeleton variant="rect" width="100%" height={70} />
              <Skeleton variant="rect" width="100%" height={70} />
            </>
          )}
        </div>

        {errorMessage && <div className={styles.subTitle}>{errorMessage}</div>}

        {checkExistDescriptionContent && (
          <React.Fragment key={uuidv4()}>
            <Alert className={styles.bank_info} icon={false} severity="info">
              <Grid container direction="row" justifyContent="space-between">
                <Grid
                  item
                  spacing={2}
                  className={styles.content}
                  dangerouslySetInnerHTML={{
                    __html: description,
                  }}
                />
              </Grid>
            </Alert>
          </React.Fragment>
        )}
      </FormControl>
    </>
  );
};

export default PaymentMethodWeb;
